export const rootTranslate = 'resources.import_vehicles';
